<template>
  <div class="container-f2g black-container extra-padding-hp">
    <!-- <ValidationObserver ref="observer" v-slot="{invalid, handleSubmit}"> -->
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <div class="container-max-width-570 extra-padding-hp">
        <div class="title-quicklink1">
          {{ content["f2g.anonymoustopupstep1.title"] }}
        </div>
        <div class="title-quicklink4">
          {{ content["f2g.anonymoustopupstep1.subtitle"] }}
        </div>
        <div class="form-overlay">
          <div class="mini-title-blue">
            {{ content["f2g.anonymoustopupstep1.header"] }}
          </div>
          <div class="title-quicklink3">
            {{ content["f2g.anonymoustopupstep1.paraggraph"] }}
          </div>
          <div class="form-input-f2g">
            <ValidationProvider
              name="αριθμός κινητού"
              mode="eager"
              :rules="{ required: true, regex: /^69\d{8}$/ }"
              v-slot="{ errors }"
            >
              <div class="form-field">
                <label class="form-label" for="Msisdn">{{
                  content["f2g.anonymoustopupstep1.label1"]
                }}</label>
                <input
                  class="overlay-input-text form-input"
                  id="Msisdn"
                  maxlength="10"
                  name="Msisdn"
                  type="text"
                  v-model="msisdn"
                  @input="errorMessage = ''"
                  @change="matchMsisdn()"
                />
                <p class="element-not-match">
                  <span v-if="errorMessage == ''">{{ errors[0] }}</span>
                  <span v-else v-html="errorMessage"></span>
                </p>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="επιβεβαίωση αριθμού"
              mode="eager"
              :rules="{ required: true }"
              v-slot="{ errors }"
            >
              <div class="form-field">
                <label class="form-label" for="confirmMsisdn">{{
                  content["f2g.anonymoustopupstep1.label3"]
                }}</label>
                <input
                  class="overlay-input-text form-input"
                  id="confirmMsisdn"
                  maxlength="10"
                  name="confirmMsisdn"
                  type="text"
                  v-model="confirmMsisdn"
                  @change="matchMsisdn()"
                />
                <p class="element-not-match">
                  <span v-if="msisdnError == ''">{{ errors[0] }}</span>
                  <span v-else v-html="msisdnError"></span>
                </p>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="email"
              mode="eager"
              :rules="{ required: true, email: true }"
              v-slot="{ errors }"
            >
              <div class="form-field">
                <label class="form-label" for="Email">{{
                  content["f2g.anonymoustopupstep1.label2"]
                }}</label>
                <input
                  type="text"
                  id="Email"
                  name="Email"
                  v-model="email"
                  class="overlay-input-text form-input"
                />
                <p class="element-not-match">
                  <span>{{ errors[0] }}</span>
                </p>
              </div>
            </ValidationProvider>
          </div>
          <div id="captcha-box" v-show="captchaVersion == 'v2'">
            <div id="captchaTest"></div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <p class="error"><span class="field-validation-error"></span></p>
              </div>
            </div>
          </div>
        </div>

        <div
          id="buttonContainer"
          v-bind:class="[
            'overlay-button-container',
            { 'disabled-button': !(isEmailValid(email) && isMsisdnValid(msisdn)) },
          ]"
        >
          <input
            id="myf2g-topup-step1"
            type="submit"
            :value="content['f2g.anonymoustopupstep1.button']"
            class="container-button"
            v-bind:class="[
              'container-button',
              { 'blue-btn': isEmailValid(email) && isMsisdnValid(msisdn) },
            ]"
            @click="handleSubmit(submitForm)"
            :disabled="!(isEmailValid(email) && isMsisdnValid(msisdn))"
          />
        </div>
        <p class="recaptcha-disclaimer">
          This site is protected by reCAPTCHA <br />
          and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import $ from "jquery";
import validator from "validator";

export default {
  name: "Step1",
  components: {},
  data: function () {
    return {
      errorMessage: "",
      msisdnError: "",
      msisdn: "",
      confirmMsisdn: "",
      email: "",
      captchaVersion: "v3",
      content: "",
    };
  },
  created() {
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let configWCS = {
      sessionKey: "wcs_f2g_anonymous_topup_step1_mock",
      axiosConfig: {
        method: "get",
        url: "/gr/f2g/vueContentService/",
        params: {
          ciKey: "f2ganonymoustopupstep1mock",
          locale: self.locale,
        },
      },
    };

    this.fetchDataFromWCS(configWCS)
      .then((response) => {
        console.log(JSON.stringify(response));
        self.content = response;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        console.log("finally");
      });
  },
  mounted() {
    var myInput = document.getElementById("confirmMsisdn");
    myInput.onpaste = (e) => e.preventDefault();
    this.$nextTick(function () {
      this.addStyling();
    });
  },
  computed: {
    getMsisdn() {
      return this.$store.state.msisdn;
    },
    getEmail() {
      return this.$store.state.email;
    },
    locale() {
      return this.$store.state.locale;
    },
  },
  methods: {
    isEmailValid(email) {
      return validator.isEmail(this.email);
    },
    isMsisdnValid(msisdn) {
      return /^69\d{8}$/.test(msisdn);
    },
    matchMsisdn() {
      var locale = document.getElementsByTagName("body")[0].dataset.locale;
      if (
        this.confirmMsisdn == "" ||
        this.msisdn == "" ||
        this.msisdn == this.confirmMsisdn
      ) {
        this.msisdnError = "";
        return true;
      } else {
        locale == "en_US"
          ? (this.msisdnError = "Numbers do not match.")
          : (this.msisdnError = "Ο αριθμός που συμπλήρωσες είναι διαφορετικός.");
        return false;
      }
    },
    submitForm() {
      if (this.matchMsisdn()) {
        if (this.validateCaptcha()) {
          this.$store.commit("showLoader");
          this.$store.commit("setMsisdn", this.msisdn);
          this.$store.commit("setEmail", this.email);
          this.etopupAnonymousAuthentication();
        }
      }
    },
    validateCaptcha() {
      if (
        this.captchaVersion == "v2" &&
        grecaptcha.getResponse(this.widgetId).length == 0
      ) {
        $("body").data("locale") == "el_GR"
          ? $("#captcha-box > div > div > p > span").html(
              "To captcha πρέπει να συμπληρωθεί."
            )
          : $("#captcha-box > div > div > p > span").html("Please fill in the captcha.");
        $("#captcha-box > div > div > p > span").show();
      } else {
        $("#captcha-box > div > div > p > span").html("");
        $("#captcha-box > div > div > p > span").hide();
      }
      return (
        this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0
      );
    },
    etopupAnonymousAuthentication() {
      var input = {
        msisdn: this.getMsisdn,
        email: this.getEmail,
      };
      input.caller = {
        callingSystem: "myF2Gweb",
        salesCode: "",
        username: "username",
        channel: "F2G",
      };
      input.caller.locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";

      //document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";

      var self = this;
      var v3Key = document.getElementsByTagName("body")[0].dataset.captchav3;
      grecaptcha.ready(function () {
        grecaptcha
          .execute(v3Key, { action: "onlineTopupWithoutLogin" })
          .then(function (token) {
            input.captchaToken = token;
            if (self.captchaVersion == "v2") {
              console.log("Using v2 token instead.");
              input.captchaToken = grecaptcha.getResponse(self.widgetId);
            }
            input.captchaVersion = self.captchaVersion;
            // console.log(input);
            self
              .axios({
                method: "post",
                url: "/apiv2/topup/etopupAnonymousAuthentication/",
                data: input,
              })
              .then((response) => {
                console.log(
                  "etopupAnonymousAuthentication response: " +
                    JSON.stringify(response.data)
                );
                self.$store.commit("hideLoader");
                if (response.data.success == true && response.data.errorLevel == 0) {
                  self.$store.commit("setToken", response.data.token);
                  self.$store.commit("changeStep", "3");
                  self.$store.commit("hideLoader");
                  var anonymous_infos = {};
                  anonymous_infos.token = response.data.token;
                  anonymous_infos.msisdn = self.getMsisdn;
                  anonymous_infos.email = self.getEmail;
                  anonymous_infos.currentStep = "3";
                  sessionStorage.setItem(
                    "anonymous_infos_F2G",
                    JSON.stringify(anonymous_infos)
                  );
                } else {
                  if (response.data.errorCode == "1001") {
                    console.log(`Error: ${response.data.errorMessage}`);
                    self.errorMessage = response.data.errorMessage;
                  } else if (response.data.errorCode == "1006") {
                    if (self.captchaVersion != "v2") {
                      var v2Key = document.getElementsByTagName("body")[0].dataset
                        .captchav2;
                      grecaptcha.ready(() => {
                        self.widgetId = grecaptcha.render("captchaTest", {
                          sitekey: v2Key,
                          theme: "light",
                        });
                      });
                    }
                    self.captchaVersion = "v2";
                  } else {
                    console.log(`Error: ${response.data.errorMessage}`);

                    self.errorMessage = response.data.errorMessage;
                  }
                }
              })
              .catch((error) => {
                console.log(
                  "etopupAnonymousAuthentication responded with error: " + error
                );
                self.$store.commit("hideLoader");
                self.errorMessage = "Error";
              });
          });
      });
    },
    addStyling() {
      $("input").focus(function () {
        $(this).parents(".form-field").addClass("focused");
      });

      $("input").blur(function () {
        var inputValue = $(this).val();
        if (inputValue == "") {
          $(this).removeClass("filled");
          $(this).parents(".form-field").removeClass("focused");
        } else {
          $(this).addClass("filled");
        }
      });
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none;
}

p.recaptcha-disclaimer {
  font-family: Manrope-Normal;
  color: #ada8a0;
  font-size: 1.4rem;
  line-height: 1.9rem;
  margin: 4.4rem 1.4rem;
  text-align: center;
}

p.recaptcha-disclaimer a {
  color: #ada8a0;
  text-decoration: underline;
}
</style>
